import React from 'react'

import { Button, Form, Header } from 'semantic-ui-react'

const MyTeamLegalCompliance = ({
  contentOwner,
  controllerPrivacyUrl,
  legalDisclosureUrl,
  defaultAdditionalDeclarationEnabled,
  defaultAdditionalDeclarationText,
  isMobile,
  handleChange,
  handleSubmit,
}: IProps) => (
  <>
    <Header as="h3">Legal & Compliance</Header>
    <p style={{ color: '#6b7280' }}>
      Set the default legal identity and contributor notices for this workspace. Projects can override these settings
      when a client or campaign has different legal requirements.
    </p>
    <p style={{ color: '#6b7280', marginTop: '-0.5rem' }}>
      Need help?{' '}
      <a
        href="https://vloggi.com/docs/how-to-set-legal-entity-privacy-and-declaration-details-in-vloggi/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Read how to set legal entity, privacy and declaration details.
      </a>
    </p>

    <Form>
      <Form.Field>
        <Form.Input
          type="text"
          label="Legal entity name"
          placeholder="e.g. Northstar Energy Holdings LLC"
          name="contentOwner"
          value={contentOwner || ''}
          onChange={handleChange}
        />
        <small style={{ color: '#6b7280' }}>
          The legal organization that controls contributor data. This may differ from the public team or brand name.
        </small>
      </Form.Field>

      <Form.Field>
        <label>Controller privacy policy URL</label>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          <div style={{ flex: 1 }}>
            <Form.Input
              type="text"
              placeholder="https://www.example.com/privacy"
              name="controllerPrivacyUrl"
              value={controllerPrivacyUrl || ''}
              onChange={handleChange}
            />
          </div>

          {controllerPrivacyUrl && (
            <a
              href={controllerPrivacyUrl.startsWith('http') ? controllerPrivacyUrl : `https://${controllerPrivacyUrl}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                whiteSpace: 'nowrap',
                alignSelf: 'center',
                marginBottom: '1em',
              }}
            >
              Test link
            </a>
          )}
        </div>
        <small style={{ color: '#6b7280' }}>
          Shown to contributors so they can read how your organization processes their personal data.
        </small>
      </Form.Field>

      <Form.Field>
        <label>Legal disclosure / Impressum URL</label>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          <div style={{ flex: 1 }}>
            <Form.Input
              type="text"
              placeholder="https://www.example.com/impressum"
              name="legalDisclosureUrl"
              value={legalDisclosureUrl || ''}
              onChange={handleChange}
            />
          </div>

          {legalDisclosureUrl && (
            <a
              href={legalDisclosureUrl.startsWith('http') ? legalDisclosureUrl : `https://${legalDisclosureUrl}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                whiteSpace: 'nowrap',
                alignSelf: 'center',
                marginBottom: '1em',
              }}
            >
              Test link
            </a>
          )}
        </div>
        <small style={{ color: '#6b7280' }}>
          Optional. Used where a formal legal notice, Impressum or company disclosure page is required.
        </small>
      </Form.Field>

      <Form.Field>
        <Form.Checkbox
          label="Enable default additional declaration"
          name="defaultAdditionalDeclarationEnabled"
          checked={!!defaultAdditionalDeclarationEnabled}
          onChange={handleChange}
        />
        <small style={{ color: '#6b7280' }}>
          Adds an extra contributor confirmation checkbox to new projects by default.
        </small>
      </Form.Field>

      <Form.Field>
        <Form.Input
          type="text"
          label="Default additional declaration text"
          placeholder="e.g. I confirm I have permission from all people shown in this content."
          name="defaultAdditionalDeclarationText"
          value={defaultAdditionalDeclarationText || ''}
          onChange={handleChange}
        />
      </Form.Field>

      <Button primary fluid={isMobile} onClick={handleSubmit}>
        Update
      </Button>
    </Form>
  </>
)

interface IProps {
  contentOwner?: string
  controllerPrivacyUrl?: string
  legalDisclosureUrl?: string
  defaultAdditionalDeclarationEnabled?: boolean
  defaultAdditionalDeclarationText?: string
  isMobile: boolean
  handleChange: (event: any, data: any) => void
  handleSubmit: () => void
}

export default MyTeamLegalCompliance
